// extracted by mini-css-extract-plugin
export var statItem = "_cn-1";
export var statsRow = "_cn-0";